/* eslint-disable */

export function rippleEvents() {
  $(document).on('click', '.ripplelink', function (e) {
    e.preventDefault();
    var rippleContainer = $(e.target).hasClass('ripplelink-container') ? $(e.target) : $(e.target).closest('.ripplelink').find('.ripplelink-container');
    var inkEl = rippleContainer.find('.ink');

    if (inkEl.length) {
      inkEl.removeClass('animate');
    }
    else {

      inkEl = $('<span class="ink"></span>');
      inkEl.get(0).style.width = inkEl.get(0).style.height = Math.max(rippleContainer.get(0).offsetWidth, rippleContainer.get(0).offsetHeight) + 'px';
      rippleContainer.append(inkEl);
    }
    console.log('e.offsetX,e.offsetY', e.offsetX,e.offsetY);
    console.log('e.target offset().left', $(e.target).offset().left, $(e.target));
    inkEl.css('left', ((e.pageX - $(rippleContainer).offset().left) - inkEl.get(0).offsetWidth / 2) + 'px');
    inkEl.css('top', ((e.pageY - $(rippleContainer).offset().top) - inkEl.get(0).offsetHeight / 2) + 'px');
    inkEl.addClass('animate');
    //goto link
    if($(e.target).closest('.ripplelink').find('.ripplelink-target').length) {
      window.location.href = $(e.target).closest('.ripplelink').find('.ripplelink-target').attr('href');
    }

  });
}



// WEBPACK FOOTER //
// ./scripts/util/rippleLinks.js